import firebase from '../../lib/firebase.prod';
import * as PROJECT_CODE from '../../constants/projectCode';
import dayjs from 'dayjs';
import getRandomSalesAgent from './getRandomSalesAgent.api';

const firebaseRef = firebase.database();

export default async function getSalesAgentAppointmentTime(
	salesAgentId,
	bookedTimeArr,
	callback
) {
	var timeArr = [];
	var chooseSalesAgentId = false;

	console.log('getSalesAgentAppointmentTime salesAgentId', salesAgentId);

	firebaseRef
		.ref('/client_appointments/' + PROJECT_CODE.projectCode)
		.orderByChild('createrID')
		.equalTo(salesAgentId)
		.once('value', (snapshot) => {
			var appointmentObj = snapshot.val();

			if (appointmentObj !== null) {
				console.log('appointmentObj', appointmentObj);

				var appointmentKeys = Object.keys(appointmentObj);

				appointmentKeys.forEach((key) => {
					var timeOfAppointment =
						appointmentObj[key].timeOfAppointment;

					timeArr.push(timeOfAppointment);
				});
			}
		});

	let intersectionArr = timeArr.filter((x) => bookedTimeArr.includes(x));

	console.log('intersectionArr', intersectionArr);

	if (intersectionArr.length === 0) {
		chooseSalesAgentId = true;
		callback(salesAgentId);
	} else {
		getRandomSalesAgent(bookedTimeArr, (returned) => console.log(returned));
	}
}
